import React from 'react';
import { removeLeadingZeros } from '../../../utils/utils';
import { formatDate } from '../../../utils/time';
import { singleJobPath } from '../../../constants/urls';
import { hasAlert } from '../../../constants/job';

import EditLink from './EditLink/EditLink';
import MailIcon from '@material-ui/icons/MailOutline';
import { Icon, Typography } from '@material-ui/core';

export const getJobTableColumns = (t, user) => {
  if (user && user.role) {
    if (user.role.serviceTechnologyCenterRelated) {
      return serviceTechnologyCenterJobTableColumns(t);
    }
    if (user.role.customerCenterRelated) {
      return customerCenterJobTableColumns(t);
    }
    return defaultJobTableColumns(t);
  }
  return defaultJobTableColumns(t);
}

export const defaultJobTableColumns = translations => [
  {
    colId: 1,
    text: '',
    label: '',
    colName: 'tag',
    data: null,
  },
  {
    colId: 2,
    text: translations.id,
    label: 'ID',
    colName: 'id',
    data: 'id',
  },
  {
    colId: 3,
    text: translations.createdAt,
    label: 'Created at',
    colName: 'createdAt',
    data: 'jobDate',
  },
  {
    colId: 4,
    text: translations.customer,
    label: 'Customer',
    colName: 'customer',
    data: ['customerNumber', 'customerName'],
  },
  {
    colId: 5,
    text: translations.serialProductNumber,
    label: 'Serial product number',
    colName: 'serialProductNumber',
    data: 'serviceProductNumber',
  },
  {
    colId: 6,
    text: translations.materialNumber,
    label: 'Material number',
    colName: 'materialNumber',
    data: 'materialNumber',
  },
  {
    colId: 7,
    text: translations.equipmentSerialNumber,
    label: 'Equipment serial number',
    colName: 'equipmentSerialNumber',
    data: 'equipmentSerialNumber',
  },
  {
    colId: 8,
    text: translations.customerCenterPlantCode,
    label: 'Customer center plant code',
    colName: 'customerCenterPlantCode',
    data: 'customerCenterPlantCode',
  },
  {
    colId: 9,
    text: translations.serviceTechnologyCenterPlannerGroup,
    label: 'Service technology center planner group',
    colName: 'serviceTechnologyCenterPlannerGroup',
    data: 'serviceTechnologyCenterPlannerGroup',
  },
  {
    colId: 10,
    text: translations.handledBy,
    label: 'Handled by',
    colName: 'handledBy',
    data: 'currentlyHandledBy',
  },
  {
    colId: 11,
    text: translations.reportLevel,
    label: 'Report level',
    colName: 'reportLevel',
    data: 'reportLevel'
  },
  {
    colId: 12,
    text: '',
    label: '',
    colName: 'alerts',
    data: 'alerts'
  },
  {
    colId: 13,
    text: '',
    label: '',
    colName: 'edit',
    data: true,
  },
];

export const customerCenterJobTableColumns = translations => [
  {
    colId: 1,
    text: '',
    label: '',
    colName: 'tag',
    data: null,
  },
  {
    colId: 2,
    text: translations.id,
    label: 'ID',
    colName: 'id',
    data: 'id',
  },
  {
    colId: 3,
    text: translations.createdAt,
    label: 'Created at',
    colName: 'createdAt',
    data: 'jobDate',
  },
  {
    colId: 4,
    text: translations.customer,
    label: 'Customer',
    colName: 'customer',
    data: ['customerNumber', 'customerName'],
  },
  {
    colId: 5,
    text: translations.notificationNumber,
    label: 'Notification number',
    colName: 'notificationNumber',
    data: 'notificationNumber'
  },
  {
    colId: 6,
    text: translations.materialNumber,
    label: 'Material number',
    colName: 'materialNumber',
    data: 'materialNumber',
  },
  {
    colId: 7,
    text: translations.equipmentSerialNumber,
    label: 'Equipment serial number',
    colName: 'equipmentSerialNumber',
    data: 'equipmentSerialNumber',
  },
  {
    colId: 8,
    text: translations.customerCenterPlantCode,
    label: 'Customer center plant code',
    colName: 'customerCenterPlantCode',
    data: 'customerCenterPlantCode',
  },
  {
    colId: 9,
    text: translations.serviceTechnologyCenterPlannerGroup,
    label: 'Service technology center planner group',
    colName: 'serviceTechnologyCenterPlannerGroup',
    data: 'serviceTechnologyCenterPlannerGroup',
  },
  {
    colId: 10,
    text: translations.handledBy,
    label: 'Handled by',
    colName: 'handledBy',
    data: 'currentlyHandledBy',
  },
  {
    colId: 11,
    text: translations.reportLevel,
    label: 'Report level',
    colName: 'reportLevel',
    data: 'reportLevel'
  },
  {
    colId: 12,
    text: '',
    label: '',
    colName: 'alerts',
    data: 'alerts'
  },
  {
    colId: 13,
    text: '',
    label: '',
    colName: 'edit',
    data: true,
  },
];

export const serviceTechnologyCenterJobTableColumns = translations => [
  {
    colId: 1,
    text: '',
    label: '',
    colName: 'tag',
    data: null,
  },
  {
    colId: 2,
    text: translations.reportLevel,
    label: 'Report level',
    colName: 'reportLevel',
    data: 'reportLevel'
  },
  {
    colId: 3,
    text: translations.notificationNumber,
    label: 'Notification number',
    colName: 'notificationNumber',
    data: 'notificationNumber'
  },
  {
    colId: 4,
    text: translations.materialDescription,
    label: 'Material description',
    colName: 'materialDescription',
    data: 'materialDescription'
  },
  {
    colId: 5,
    text: translations.handledBy,
    label: 'Handled by',
    colName: 'handledBy',
    data: 'currentlyHandledBy',
  },
  {
    colId: 6,
    text: translations.customerName,
    label: 'Customer name',
    colName: 'customerName',
    data: 'customerName',
  },
  {
    colId: 7,
    text: translations.equipmentSerialNumber,
    label: 'Equipment serial number',
    colName: 'equipmentSerialNumber',
    data: 'equipmentSerialNumber',
  },
  {
    colId: 8,
    text: translations.receivedDate,
    label: 'Received date',
    colName: 'receivedDate',
    data: 'receivedDate',
  },
  {
    colId: 9,
    text: translations.customerCenterName,
    label: 'Customer center name',
    colName: 'customerCenterName',
    data: 'customerCenterName',
  },
  {
    colId: 10,
    text: <MailIcon />,
    label: '',
    colName: 'unreadMessages',
    data: 'numberOfUnreadMessages',
  },
  {
    colId: 11,
    text: '',
    label: '',
    colName: 'alerts',
    data: 'alerts'
  },
  {
    colId: 12,
    text: '',
    label: '',
    colName: 'edit',
    data: true,
  },
];

export const renderProperDataFormat = (row, data, gt) => {
  const { colName, data: field } = row;
  const hasAlerts = hasAlert(data.alerts);

  if (colName === 'edit') return <EditLink hasAlerts={hasAlerts} path={singleJobPath(data.id)} />;
  if (colName === 'unreadMessages' && data[field] === 0) return 0;
  if (colName === 'customer') return (`${removeLeadingZeros(data[field[0]])} - ${data[field[1]]}`);
  if (colName === 'equipmentSerialNumber') return data[field] ? removeLeadingZeros(data[field]) : <Typography color='error'>{gt.serialNumberMissing}</Typography>;

  if (colName && data[field]) {
    switch (colName) {
      case 'createdAt':
      case 'receivedDate':
        return formatDate(data[field]);
      case 'notificationNumber':
        return removeLeadingZeros(data[field]);
      case 'alerts':
        return data[field].length > 0 ? <Icon fontSize="default" color='error'>error</Icon> : null;
      default:
        return data[field];
    }
  }

  return null
}

export const smallScreens = ['xs', 'sm'];



// WEBPACK FOOTER //
// ./src/components/Jobs/Job/constants.js